export default __webpack_public_path__ + "static/media/friends.750fb1cd.svg";